import React from "react";
import noAvatar from "./../../Imgs/avatar_placeholder.jpg";
const ProfileLeft = ({ user = {} }) => {
  return (
    <div className="col-span-1 p-3 dark:dark-bg-front bg-front rounded-lg box">
      <h2 className="text-2xl font-bold mb-2 text-center">Profile Picture</h2>
      <img
        src={user?.img || noAvatar}
        alt="Profile"
        className="rounded-3xl w-24 md:w-32 lg:w-40 mx-auto h-auto my-5"
      />
      <h2 className="text-xl font-thin my-5 text-center">TeS{user?.id}</h2>
    </div>
  );
};

export default ProfileLeft;
